// extracted by mini-css-extract-plugin
export var dropdownButton = "_1w-0";
export var fullWidthDropdownButton = "_1w-1";
export var icon = "_1w-3";
export var iconPlaceholder = "_1w-2";
export var shortcutContainer = "_1w-4";